import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../types/store'
import { alertErrorMessage } from '../../../../utils/Errors'
import { getUrlWithVersion } from '../../../../api/api'

export const fetchQuickAccessProducts = createAsyncThunk<
    { quickAccessProductsIds: string[] },
    void,
    ThunkConfig<string>
>('productsSlice/fetchQuickAccessProducts', async (_, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    try {
        const { data } = await api.get<string[]>(
            getUrlWithVersion(`/users/current/quick_access`)
        )
        return { quickAccessProductsIds: data }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to fetch quick access products')
    }
})
